import { useMemo } from 'react';

import type { AcceptanceTimeItem } from '@/app/types/Dashboard';
import type { ColorString } from 'highcharts';
import type Highcharts from 'highcharts';

export const config: Highcharts.Options = {
	chart: {
		type: 'bar',
		height: 270,
		marginBottom: 36,
		backgroundColor: 'transparent',
	},
	credits: {
		enabled: false,
	},
	title: {
		text: '',
	},
	accessibility: {
		enabled: false,
	},
	xAxis: {
		type: 'category',
		offset: 20,

		labels: {
			y: 6,
			x: 0,

			style: {
				fontSize: '16px',
				fontFamily: 'Graphik',
				fontWeight: '600',
				height: 120,
			},

			align: 'left',
			formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
				return `<div style="display: flex; align-items: center; justify-content: flex-start; min-height:20px; height: 20px;">
			 				<div style="color: ${this.axis.series[this.pos].color as ColorString}; font-size:16px; font-family: Graphik-Semibold; margin-right: 08px">&#9679;</div>
				 			<span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-family: Graphik; font-size: 16px;">${this.value}</span>
						</div>`;
			},
			useHTML: true,
			reserveSpace: true,
		},
		lineWidth: 0,
	},
	yAxis: {
		title: {
			text: 'Seconds',
			style: {
				fontSize: '14px',
				color: '#B6B6B6',
				fontFamily: 'Graphik',
				textOverflow: 'none',
				fontWeight: '600',
				width: 150,
				height: 20,
			},
			y: -16,
			x: 0,
			margin: 0,
		},
		labels: {
			align: 'center',
			style: {
				fontSize: '14px',
				color: '#B6B6B6',
				fontFamily: 'Graphik',
				fontWeight: '600',
				alignItems: 'center',
				textAlign: 'center',
				height: 20,
			},
			useHTML: true,
			reserveSpace: true,
			formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
				if (this.isFirst || this.isLast) {
					return `${this.value}`;
				}
				return '';
			},
			y: 20,
		},

		alignTicks: true,
		allowDecimals: false,
		startOnTick: true,
		endOnTick: true,
		gridLineDashStyle: 'Dash',
		gridLineColor: '#9194A1',
		tickAmount: 7,
		min: 0,
		showFirstLabel: true,
		showLastLabel: true,
	},
	legend: {
		enabled: false,
	},
	tooltip: {
		enabled: false,
	},
	plotOptions: {
		bar: {
			grouping: false,
			dataLabels: {
				enabled: true,
				verticalAlign: 'middle',
				color: 'transparent',
				style: {
					fontSize: '16px',
					fontFamily: 'Graphik-Semibold',
					fontWeight: '400',
					textOutline: 'none',
				},
			},
		},
	},
	series: [
		{
			name: 'Org 1',
			type: 'bar',
			borderRadius: 6,
			pointWidth: 10,
			data: [{ y: 45, name: 'Org 1' }],
			dataLabels: {
				enabled: true,
				color: 'red',
			},
		},
		{
			borderRadius: 6,
			pointWidth: 10,
			name: 'Organization 2',
			type: 'bar',
			data: [{ y: 14, name: 'Organization 2 With a very' }],
			dataLabels: {
				enabled: true,
				color: 'red',
			},
		},
		{
			borderRadius: 6,
			pointWidth: 10,
			name: 'Organization 3',
			type: 'bar',
			data: [{ y: 27, name: ' Organization 3' }],
			dataLabels: {
				enabled: true,
				color: 'red',
			},
		},
	],
};

export const useFormattedData = (data: AcceptanceTimeItem[] = []) => {
	return useMemo(() => {
		try {
			if (!data || data.length === 0) {
				return null;
			}

			const series =
				data.map((item) => {
					return {
						colorKey: 'x',
						name: item.organizationName,
						data: [{ y: item.averageTime, name: item.organizationName }],
						type: 'bar',
						borderRadius: 6,
						pointWidth: 9,
						color: item.color,
						dataLabels: {
							enabled: true,
							color: item.color,
						},
					};
				}) ?? [];

			return {
				...config,
				chart: {
					...config.chart,
					scrollablePlotArea: {
						minHeight: 22 * series.length,
						scrollPositionY: 0,
					},
				},
				xAxis: {
					...config.xAxis,
				},
				yAxis: {
					...config.yAxis,
				},
				series: series,
			};
		} catch {
			return null;
		}
	}, [data]);
};
